import {
    URLAPI,
    VACANCIES_NOTIFICATION_PATH,
    VACANCIES_NOTIFICATION_CREATE_PATH,
    VACANCIES_NOTIFICATION_UPDATE_PATH,
    VACANCIES_NOTIFICATION_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_vacancies_notification: {
        data: [],

        status: 0,
        message: {},
    },

    _create_vacancies_notification: {
        data: {},
        status: 0,
        message: {},
    },
    _update_vacancies_notification: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_vacancies_notification: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_VACANCIES_NOTIFICATION = "GET_ALL_VACANCIES_NOTIFICATION";
export const CREATE_VACANCIES_NOTIFICATION = "CREATE_VACANCIES_NOTIFICATION";
export const UPDATE_VACANCIES_NOTIFICATION = "UPDATE_VACANCIES_NOTIFICATION";
export const DELETE_VACANCIES_NOTIFICATION = "DELETE_VACANCIES_NOTIFICATION";

export const vacancies_notification_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_VACANCIES_NOTIFICATION:
            return {
                ...state,
                _get_all_vacancies_notification: action.payload,
            };
        case CREATE_VACANCIES_NOTIFICATION:
            return {
                ...state,
                _create_vacancies_notification: action.payload,
            };
        case UPDATE_VACANCIES_NOTIFICATION:
            return {
                ...state,
                _update_vacancies_notification: action.payload,
            };
        case DELETE_VACANCIES_NOTIFICATION:
            return {
                ...state,
                _delete_vacancies_notification: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllVacanciesNotification = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${VACANCIES_NOTIFICATION_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_VACANCIES_NOTIFICATION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_VACANCIES_NOTIFICATION,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_VACANCIES_NOTIFICATION,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const createVacanciesNotification = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${VACANCIES_NOTIFICATION_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_VACANCIES_NOTIFICATION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_VACANCIES_NOTIFICATION,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_VACANCIES_NOTIFICATION,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateVacanciesNotification = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${VACANCIES_NOTIFICATION_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_VACANCIES_NOTIFICATION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_VACANCIES_NOTIFICATION,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_VACANCIES_NOTIFICATION,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteVacanciesNotification = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${VACANCIES_NOTIFICATION_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_VACANCIES_NOTIFICATION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_VACANCIES_NOTIFICATION,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_VACANCIES_NOTIFICATION,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_vacancies_notification = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
